import * as actionTypes from './actionTypes';
import { UbigeoModel } from '@app/src/common/PredictiveInput/DataListModel';

interface State {
  data: UbigeoModel[];
  isFetching: boolean;
  error: boolean;
  ubigeo: string;
  message: string;
  inputValue: string;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  ubigeo: null,
  message: '',
  inputValue: ''
}

export const district = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_DISTRICT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_DISTRICT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_DISTRICT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data,
        ubigeo: state.ubigeo,
      }
    case actionTypes.SET_DISTRICT_FULLDATA:
      return {
        ...state,
        ubigeo: action.data
      }
    case actionTypes.SET_DISTRICT_MESSAGE:
      return {
        ...state,
        message: action.message
      }
    case actionTypes.SET_DISTRICT_INPUT_VALUE:
      return {
        ...state,
        inputValue: action.value
      }
    case actionTypes.CLEAR_DISTRICT_FULLDATA:
      return {
        ...state,
        ubigeo: null
      }
    case actionTypes.CLEAR_DISTRICT_DATA:
      return {
        ...state,
        data: [],
        message: ''
      }
    case actionTypes.CLEAR_DISTRICT_MESSAGE:
      return {
        ...state,
        message: ''
      }
    case actionTypes.CLEAR_DISTRICT_INPUT_VALUE:
      return {
        ...state,
        inputValue: ''
      }
    default:
      return state;
  }
}
